import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

// PRD2030_R01 전용 DTO (백엔드 PRD2030_R01RowDto 매핑)
export interface PRD2030_R01Dto extends ProductWorkDto {
	
	itemSpec: string;
	itemUnit: string;

}

export type GridRowData = PRD2030_R01Dto;

export const defaultProductResultData: PRD2030_R01Dto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

	productWorkNo: '',
	compCd: '',
	compNm: '',
	workDt: formatDate(new Date()),
	fromTime: toLocalDateTime(new Date()),
	toTime: toLocalDateTime(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	orderQty: 0,
	workEmp: '',
	workEmpNm: '',
	resultQty: 0,
	productOrderNo: '',
	closeTag: "N",
	remark: '',

	itemSpec: '',
	itemUnit: '',

    inserted: false,
    isModified: false,
};

